export function getHeaders(table) {
	return table.map((items) => items.map((item) => ({
		index: item.index,
		header: item.header
	})));
}

export function getColumns(table) {
	return table.reduce((acc, items) => {
		return acc.concat(...items.filter((item) => !!item.column).map((item) => ({
			index: item.index,
			column: item.column
		})));
	}, []);
}


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/new-table/helper.js